export const carProvince={
    province_list: {
    '1':'京','2':'津','3':'沪','4':'渝','5':'蒙','6':'新','7':'藏','8':'宁','9':'桂','10':'港',
    '11':'澳','12':'黑','13':'吉','14':'辽','15':'晋','16':'冀','17':'青','18':'鲁','19':'豫',
    '20':'苏','21':'皖','22':'浙','23':'闽','24':'赣','25':'湘','26':'粤','27':'琼','28':'甘',
    '29':'陕','30':'贵','31':'云','32':'川'
    }
}
  
